module.exports = __webpack_public_path__ + "78b11edf871e45e41a4b3553a8b11a8b.pdf";